module.exports = __webpack_public_path__ + "collegiate_nannies.svg?d3c2afdd6c40cd96ff0a76b3fd10ac1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/collegiate_nannies.svg
// module id = 26
// module chunks = 0